import styled from 'styled-components'

export const StyledAccordionTitle = styled.div`
font-size: 16px !important;
`

export const StyledNoResultsMessage = styled.div`
display: flex;
justify-content: center;
margin: 10px;
.ui.placeholder.segment {
  width: 200px;
  min-height: 200px;
  border-radius: 50%;
  .header {
    margin-right: unset !important
   }
}  
`
export const FarmerGroupMonthsWrapper = styled.div`
position: relative;
 .actions {
  display: flex;
  align-items: baseline;
  justify-content: end;
  gap: 10px;
 }
`